import React, { useContext, useEffect, useState } from 'react'
import { usePDF } from 'react-to-pdf';
import { barely, reciept_header, Footer_img, ReceiptWRD } from '../../../public/LoginImages/importimages'
import './innercss.css'
import UserApplication from "../UserContext/UserContext";
import { useParams } from 'react-router-dom'
const Reciept = () => {
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const { tid, gst, panno } = useParams()
    const [hidden, sethidden] = useState(false)
    const stateCalls = useContext(UserApplication)
    const [paymentdata, setpaymentdata] = useState({})
    const { DownloadReciept } = stateCalls
    useEffect((e) => {
        try {
            drecipet()
        } catch (error) {
            console.error('Error in useEffect:', error);
            throw error;
        }
    }, [])

    async function drecipet(params) {
        try {
            let data = await DownloadReciept(tid, gst, panno)
            console.log(data)
            setpaymentdata(data[0])
        } catch (error) {
            console.error('Error in drecipet:', error);
            throw error;
        }
    }

    return (
        <>
            <div style={{ display: 'grid', justifyContent: 'center' }}>

                <div id='reciept' ref={targetRef} style={{ display: 'grid', justifyContent: 'center', width: '100%', height: '100%' }} >
                    <div className="card mb-3">
                        <img src={ReceiptWRD} className="card-img-top" alt="..." style={{ width: '100%' }} />
                        <div className="card-body d-flex" style={{ justifyContent: 'space-between' }}>
                            <span className='w-50' style={{ textAlign: 'left' }} >
                                <h6 className="">Scheme Name: {paymentdata.Tender_Name}</h6>
                                <h6 className="">Description: {paymentdata.Description}</h6>
                                <h6 className="">Name: {paymentdata.Bidder_CompanyName || paymentdata.firstname}</h6>
                                <h6 className="">Email: {paymentdata.Email || paymentdata.email}</h6>
                            </span>
                            <span className='w-50' style={{ textAlign: 'right' }}>
                                <h6 className="">Transaction ID: {paymentdata.easepayid}</h6>
                                <h6 className="">Date : {paymentdata.addedon}</h6>
                                <h6 className="">GST No: {paymentdata.GST_No}</h6>
                                {/* <h6 className="my-3">Payment Status: {paymentdata.status}</h6> */}
                                {
                                    paymentdata.status == "success" ? <h6 className="my-3">Payment Status: Success</h6> : <h6 className="my-3">Payment Status: Pending</h6>
                                }
                            </span>
                        </div>
                        <div className="card" style={{ width: "100%" }}>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item" style={{ display: 'flex', backgroundColor: 'red', color: 'white' }}>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Sr no</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Particulars</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Amount</span>
                                </li>
                                <li className="list-group-item" style={{ display: 'flex' }}>
                                    <span style={{ width: '33%', textAlign: 'center' }}>1</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Emd Fee</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.ErnestMoneyDeposit}</span>
                                </li>
                                <li className="list-group-item" style={{ display: 'flex' }}>
                                    <span style={{ width: '33%', textAlign: 'center' }}>2</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Scheme Fee</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.TenderFee}</span>
                                </li>
                                <li className="list-group-item" style={{ display: 'flex' }}>
                                    <span style={{ width: '33%', textAlign: 'center' }}>3</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Gst Amount</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.GstAmount || paymentdata.GstAmount} </span>
                                </li>
                                <li className="list-group-item" style={{ display: 'flex', fontWeight: 'bold' }}>
                                    <span style={{ width: '33%', textAlign: 'center' }}>4</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>Total Amount</span>
                                    <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.PaymentAmount || paymentdata.net_amount_debit}</span>
                                </li>
                            </ul>
                            <div className='my-5' style={{ display: 'grid', justifyContent: 'center', width: "80vw", textAlign: "center" }}>
                                <div>
                                    <h3>Declaration:</h3>
                                    <p>
                                        Certified that the particulars given in invoice are true & correct and the amount represents indicates
                                        the actual price charged and that there is no additional flow of consideration directly from
                                        the Nagar Vikas Vibhag
                                    </p>
                                </div>
                            </div>
                            {/* <div className="card mb-3" style={{ border: "none" }}>
                                <img src={Footer_img} className="card-img-top" alt="..." style={{ width: '100%' }} />
                            </div> */}
                            <button onClick={() => { toPDF() }} className='btn btn-success'>print</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Reciept